import Service from '@/helpers/service'

export default {
    accountPayable(params) {
        return Service().get('accounting/account-payable/index', {params});
    },
    showAccountPayable(id) {
        return Service().get('accounting/account-payable/show/'+id);
    },
    payAccountPayable(id, params) {
        return Service().post('accounting/account-payable/pay/'+id, params);
    },
    paymentSchedule(params) {
        return Service().get('accounting/payment-schedule/index', {params});
    },
    payTerm(termId, params) {
        return Service().post('accounting/payment-schedule/pay/'+termId, params);
    },
    paymentHistory(params) {
        return Service().get('accounting/payment-history/index', {params});
    },
    deletePayment(id) {
        return Service().post('accounting/payment-history/delete/'+id);
    },
    budget(params) {
        return Service().get('accounting/budget/index', {params});
    },
    showBudget(woCode) {
        return Service().get('accounting/budget/show/'+encodeURIComponent(woCode));
    },
    saveBudget(params) {
        return Service().post('accounting/budget/save', params);
    },
    deleteBudget(id) {
        return Service().post('accounting/budget/delete/'+id);
    },
    currencyRates() {
        return Service().get('accounting/currency-rate/index');
    },
    saveCurrencyRate(params) {
        return Service().post('accounting/currency-rate/save', params);
    },
    profitLoss(params) {
        return Service().get('accounting/profit-loss/index', {params});
    },
    showProfitLoss(woCode) {
        return Service().get('accounting/profit-loss/show/'+encodeURIComponent(woCode));
    },
    saveContract(params) {
        return Service().post('accounting/profit-loss/contract/save', params);
    },
    saveInvoice(params) {
        return Service().post('accounting/profit-loss/invoice/save', params);
    },
    deleteInvoice(id) {
        return Service().post('accounting/profit-loss/invoice/delete/'+id);
    },
    saveCost(params) {
        return Service().post('accounting/profit-loss/cost/save', params);
    },
    deleteCost(id) {
        return Service().post('accounting/profit-loss/cost/delete/'+id);
    },
    supplierInvoices(params) {
        return Service().get('accounting/supplier-invoice/index', {params});
    },
    suggestInvoice(params) {
        return Service().get('accounting/supplier-invoice/suggest', {params});
    },
    saveSupplierInvoice(params) {
        return Service().post('accounting/supplier-invoice/save', params);
    },
    postSupplierInvoice(id) {
        return Service().post('accounting/supplier-invoice/post/'+id);
    },
    unpostSupplierInvoice(id) {
        return Service().post('accounting/supplier-invoice/unpost/'+id);
    },
    deleteSupplierInvoice(id) {
        return Service().post('accounting/supplier-invoice/delete/'+id);
    },
    apAging(params) {
        return Service().get('accounting/report/ap-aging', {params});
    },
    taxReport(params) {
        return Service().get('accounting/report/tax', {params});
    },
    journals(params) {
        return Service().get('accounting/journal/index', {params});
    },
    exportJournals(params) {
        return Service().get('accounting/journal/export', {params, responseType: 'blob'});
    },
    accountingSetting() {
        return Service().get('accounting/setting/index');
    },
    saveAccount(params) {
        return Service().post('accounting/setting/account/save', params);
    },
    deleteAccount(id) {
        return Service().post('accounting/setting/account/delete/'+id);
    },
    saveMappings(params) {
        return Service().post('accounting/setting/mapping/save', params);
    },
    savePphObject(params) {
        return Service().post('accounting/setting/pph-object/save', params);
    },
    saveTaxSetting(params) {
        return Service().post('accounting/setting/tax/save', params);
    },
    inventoryValue(params) {
        return Service().get('accounting/inventory/index', {params});
    },
    inventoryLedger(materialCode) {
        return Service().get('accounting/inventory/ledger/'+encodeURIComponent(materialCode));
    },
    generateOpening() {
        return Service().post('accounting/inventory/generate-opening', {}, {timeout: 600000});
    },
    updateOpeningCost(params) {
        return Service().post('accounting/inventory/opening-cost', params);
    },
    cogs(params) {
        return Service().get('accounting/inventory/cogs', {params});
    },
}
